import { module } from 'angular';
import App from '../../app';
import * as _ from 'lodash';

class UtilService {
	
	constructor($rootScope) {
		this.$rootScope = $rootScope;
		//{scope: {}, data: {}} 
		this.stateParams = {};
	}

	isEmpty(value) {
		return _.isEmpty(value);
	}
	
	uniqueId(prefix = '') {
		return _.uniqueId(prefix);
	}
	
	get(obj, key) {
		
		const _key = key.replace(/\(\)$/, '');
		return _.get(obj, _key);
	}
	
	clone(obj) {
		return _.cloneDeep(obj);
	}
	
	stringByteLength(str) {
		let byte, char, i;
		const noneAsciiCodeByte = 2;
		
		// shifting 연산으로 문자열 내부, 한글추가 여부 검사
		for (byte=i=0;char=str.charCodeAt(i++); byte+=char >> 11 ? noneAsciiCodeByte : char >> 7 ? 2:1);
		
		return byte;
	}
	
	openTab($scope, route, data, prevState){
		if(this.isEmpty(route.state)) throw new Error('state는 필수값입니다.');
		
		this.stateParams[route.state] = data;
		this.$rootScope.$emit('WRAP:MOVETAB', route, prevState);
	}
	
	setParams(state, params){
		this.stateParams[state] = params;
	}
	
	getParams(state){
		return this.stateParams[state];
	}
	
	setRegDttm(dttm){
		const yy = dttm.substring(0,4);
		const mm = dttm.substring(4,6);
		const dd = dttm.substring(6,8);
		const hh = dttm.substring(8,10);
		const mi = dttm.substring(10,12);
		const ss = dttm.substring(12,14);
		return yy+"/"+mm+"/"+dd+"  "+hh+":"+mi+":"+ss;
	}
	
	saveFile(blob, fileName){
		if(window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(blob, fileName);
		}else{
			var a = window.document.createElement('a');
			
			a.href = window.URL.createObjectURL(blob, {type: 'text/plain'});
			a.download = fileName;
			
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		}
	}
	
	isTaSysCd(syscd) {
		if(syscd === 'COO' || syscd === 'COB' || syscd === 'CAB' || 
			syscd === 'FDS' || syscd === 'IOB' || syscd === 'FEP' || syscd === 'OAG' ) {
			return true;
		}
		
		return false;
	}
	
	_getNullRecords(trgProvider, isMappingConfirm){
		let trgRows = trgProvider.getJsonRows();
		
		trgRows.map((v, idx) => {
			v.itemIndex = idx;
		});
		
		if(isMappingConfirm){
			return trgRows.filter(v => v.mappingTypeCd !== 'NONE' && v.mappingTypeCd !== 'PROPT').filter(v => {
				return (null === v.srcData || "" === v.srcData); 
			});
		}else{
			return trgRows.filter(v => v.mappingTypeCd !== 'NONE').filter(v => {
				return (null === v.srcData || "" === v.srcData); 
			});
		}
	}
	
	_setProblemRecordStyle(grid, prblmRcords, criteria, styles){
		prblmRcords.map(v =>{
			criteria.push('row = ' + v.itemIndex);
			styles.push('background=#ffffbf');
		});
		
		grid.setStyles({
			body: {
				dynamicStyles: [{
					criteria: criteria,
					styles: styles
				}]
			}
		});
	}
	
	getRedepSysCd(depSysCdList){
		var i = 1;
		var sysCd = '';
		depSysCdList.map(v =>{
			sysCd = sysCd + v.deploySysCd;
			if(i < depSysCdList.length){
				sysCd = sysCd + '/';
			}
			i++;
		});
		return sysCd;
	}
	
	getDeployType(deployResultCd, docNo){
		if(deployResultCd.indexOf('SUCCESS') !== -1) {
			if(deployResultCd.indexOf('_') !== -1) {
				return bxMsg('common.redeploy');
			}else if(docNo !== 'DUMMY' && !_.isEmpty(docNo)){
				return bxMsg('common.csrDeploy');
			}else{
				return bxMsg('common.normalDeploy');
			}
		}else{
			if(deployResultCd.indexOf('_') !== -1) {
				return bxMsg('common.redeployFail');
			}else{
				if(deployResultCd.indexOf('DELETE') !== -1){
					return bxMsg('common.deleteDeploy');
				}else{
					return bxMsg('common.deployFail');
				}
			}
		}
		
		return '';
	}
	
	compareAttr(toDeploy, toCompare, compareList, text){
		if(this.isDiff(toDeploy.msgTrnsfrmYn, toCompare.msgTrnsfrmYn)){
			compareList.push({infoName:text.msgTrnsfrmYn, preDepValue:toCompare.msgTrnsfrmYn, toDepValue:toDeploy.msgTrnsfrmYn});
		}
		if(this.isDiff(toDeploy.srTypeCd, toCompare.srTypeCd)){
			compareList.push({infoName:text.srTypeCd2, preDepValue:toCompare.srTypeCd, toDepValue:toDeploy.srTypeCd});
		}
		if(this.isDiff(toDeploy.syncAsyncDscd, toCompare.syncAsyncDscd)){
			compareList.push({infoName:text.syncAsyncDscd, preDepValue:toCompare.syncAsyncDscd, toDepValue:toDeploy.syncAsyncDscd});
		}
		if(this.isDiff(toDeploy.rspsYn, toCompare.rspsYn)){
			compareList.push({infoName:text.rspsYn, preDepValue:toCompare.rspsYn, toDepValue:toDeploy.rspsYn});
		}
		if(this.isDiff(toDeploy.trxTypeDscd, toCompare.trxTypeDscd)){
			compareList.push({infoName:text.trxTypeDscd, preDepValue:toCompare.trxTypeDscd, toDepValue:toDeploy.trxTypeDscd});
		}
		if(this.isDiff(toDeploy.intrfcTypeCd == 'FEP')){
			if(this.isDiff(toDeploy.instCd, toCompare.instCd)){
				compareList.push({infoName:text.instCd, preDepValue:toCompare.instCd+'/'+toCompare.instCdNm, toDepValue:toDeploy.instCd+'/'+toDeploy.instCdNm});
			}
			if(this.isDiff(toDeploy.bizCd, toCompare.bizCd)){
				compareList.push({infoName:text.bizCd, preDepValue:toCompare.bizCd+'/'+toCompare.bizCdNm, toDepValue:toDeploy.bizCd+'/'+toDeploy.bizCdNm});
			}
			if(this.isDiff(toDeploy.rqstExtrnlMsgNo, toCompare.rqstExtrnlMsgNo)){
				compareList.push({infoName:text.rqstExtrnlMsgNo, preDepValue:toCompare.rqstExtrnlMsgNo, toDepValue:toDeploy.rqstExtrnlMsgNo});
			}
			if(this.isDiff(toDeploy.rspsExtrnlMsgNo, toCompare.rspsExtrnlMsgNo)){
				compareList.push({infoName:text.rspsExtrnlMsgNo, preDepValue:toCompare.rspsExtrnlMsgNo, toDepValue:toDeploy.rspsExtrnlMsgNo});
			}
			if(this.isDiff(toDeploy.lnkgGrpId, toCompare.lnkgGrpId)){
				compareList.push({infoName:text.lnkgGrpId, preDepValue:toCompare.lnkgGrpId, toDepValue:toDeploy.lnkgGrpId});
			}
			if(this.isDiff(toDeploy.lnkgId, toCompare.lnkgId)){
				compareList.push({infoName:text.lnkgId, preDepValue:toCompare.lnkgId, toDepValue:toDeploy.lnkgId});
			}
			if(this.isDiff(toDeploy.fepDto.timeOut, toCompare.fepDto.timeOut)){
				compareList.push({infoName:text.timeout, preDepValue:toCompare.fepDto.timeOut, toDepValue:toDeploy.fepDto.timeOut});
			}
			if(this.isDiff(toDeploy.fepDto.timeOutProcMode, toCompare.fepDto.timeOutProcMode)){
				compareList.push({infoName:text.timeOutProcMode, preDepValue:toCompare.fepDto.timeOutProcMode, toDepValue:toDeploy.fepDto.timeOutProcMode});
			}
			if(this.isDiff(toDeploy.fepDto.delayRspsYn, toCompare.fepDto.delayRspsYn)){
				compareList.push({infoName:text.delayRspsYn, preDepValue:toCompare.fepDto.delayRspsYn, toDepValue:toDeploy.fepDto.delayRspsYn});
			}
			if(this.isDiff(toDeploy.fepDto.currIntrfcIdentifier, toCompare.fepDto.currIntrfcIdentifier)){
				compareList.push({infoName:text.currIntrfcIdentifier, preDepValue:toCompare.fepDto.currIntrfcIdentifier, toDepValue:toDeploy.fepDto.currIntrfcIdentifier});
			}
			if(this.isDiff(toDeploy.fepDto.privacyInclYn, toCompare.fepDto.privacyInclYn)){
				compareList.push({infoName:text.privacyInclYn, preDepValue:toCompare.fepDto.privacyInclYn, toDepValue:toDeploy.fepDto.privacyInclYn});
			}
			if(this.isDiff(toDeploy.fepDto.encTargetYn, toCompare.fepDto.encTargetYn)){
				compareList.push({infoName:text.encTargetYn, preDepValue:toCompare.fepDto.encTargetYn, toDepValue:toDeploy.fepDto.encTargetYn});
			}
			if(this.isDiff(toDeploy.fepDto.trnsmsnErrResYn, toCompare.fepDto.trnsmsnErrResYn)){
				compareList.push({infoName:text.trnsmsnErrResYn, preDepValue:toCompare.fepDto.trnsmsnErrResYn, toDepValue:toDeploy.fepDto.trnsmsnErrResYn});
			}
			if(this.isDiff(toDeploy.fepDto.reqWrapperDtoNm, toCompare.fepDto.reqWrapperDtoNm)){
				compareList.push({infoName:text.reqWrapperDtoNm, preDepValue:toCompare.fepDto.reqWrapperDtoNm, toDepValue:toDeploy.fepDto.reqWrapperDtoNm});
			}
			if(this.isDiff(toDeploy.fepDto.resWrapperDtoNm, toCompare.fepDto.resWrapperDtoNm)){
				compareList.push({infoName:text.resWrapperDtoNm, preDepValue:toCompare.fepDto.resWrapperDtoNm, toDepValue:toDeploy.fepDto.resWrapperDtoNm});
			}
			if(this.isDiff(toDeploy.fepDto.backupAprvStat, toCompare.fepDto.backupAprvStat)){
				compareList.push({infoName:text.backupAprvStat, preDepValue:toCompare.fepDto.backupAprvStat, toDepValue:toDeploy.fepDto.backupAprvStat});
			}
			if(this.isDiff(toDeploy.fepDto.relationTrxCd, toCompare.fepDto.relationTrxCd)){
				compareList.push({infoName:text.relationTrxCd, preDepValue:toCompare.fepDto.relationTrxCd, toDepValue:toDeploy.fepDto.relationTrxCd});
			}
			if(this.isDiff(toDeploy.fepDto.commNetworkIntrfcYn, toCompare.fepDto.commNetworkIntrfcYn)){
				compareList.push({infoName:text.commNetworkIntrfcYn, preDepValue:toCompare.fepDto.commNetworkIntrfcYn, toDepValue:toDeploy.fepDto.commNetworkIntrfcYn});
			}
			if(this.isDiff(toDeploy.bizStatusChkYn, toCompare.bizStatusChkYn)){
				compareList.push({infoName:text.bizStatusChkYn, preDepValue:toCompare.bizStatusChkYn, toDepValue:toDeploy.bizStatusChkYn});
			}
			if(this.isDiff(toDeploy.wrapIoSharedYn, toCompare.wrapIoSharedYn)){
				compareList.push({infoName:text.wrapIoSharedYn, preDepValue:toCompare.wrapIoSharedYn, toDepValue:toDeploy.wrapIoSharedYn});
			}
			if(this.isDiff(toDeploy.frcdTrnsmsnYn, toCompare.frcdTrnsmsnYn)){
				compareList.push({infoName:text.frcdTrnsmsnYn, preDepValue:toCompare.frcdTrnsmsnYn, toDepValue:toDeploy.frcdTrnsmsnYn});
			}
			if(this.isDiff(toDeploy.fepDto.fileId, toCompare.fepDto.fileId)){
				compareList.push({infoName:text.fileId, preDepValue:toCompare.fepDto.fileId, toDepValue:toDeploy.fepDto.fileId});
			}
			if(this.isDiff(toDeploy.fepDto.dupTrnsmsnAllwYn, toCompare.fepDto.dupTrnsmsnAllwYn)){
				compareList.push({infoName:text.dupTrnsmsnAllwYn, preDepValue:toCompare.fepDto.dupTrnsmsnAllwYn, toDepValue:toDeploy.fepDto.dupTrnsmsnAllwYn});
			}
			if(this.isDiff(toDeploy.fepDto.recordSize, toCompare.fepDto.recordSize)){
				compareList.push({infoName:text.recordSize, preDepValue:toCompare.fepDto.recordSize, toDepValue:toDeploy.fepDto.recordSize});
			}
			if(this.isDiff(toDeploy.fepDto.recordSeparator, toCompare.fepDto.recordSeparator)){
				compareList.push({infoName:text.recordSeparator, preDepValue:toCompare.fepDto.recordSeparator, toDepValue:toDeploy.fepDto.recordSeparator});
			}
			if(this.isDiff(toDeploy.fepDto.fileNm, toCompare.fepDto.fileNm)){
				compareList.push({infoName:text.fileNm, preDepValue:toCompare.fepDto.fileNm, toDepValue:toDeploy.fepDto.fileNm});
			}
			if(this.isDiff(toDeploy.fepDto.occurCycle, toCompare.fepDto.occurCycle)){
				compareList.push({infoName:text.occurCycle, preDepValue:toCompare.fepDto.occurCycle, toDepValue:toDeploy.fepDto.occurCycle});
			}
		}else if(this.isDiff(toDeploy.intrfcTypeCd == 'MCI')){
			if(this.isDiff(toDeploy.mciDto.timeOut, toCompare.mciDto.timeOut)){
				compareList.push({infoName:text.timeout, preDepValue:toCompare.mciDto.timeOut, toDepValue:toDeploy.mciDto.timeOut});
			}
			if(this.isDiff(toDeploy.mciDto.privacyInclYn, toCompare.mciDto.privacyInclYn)){
				compareList.push({infoName:text.privacyInclYn, preDepValue:toCompare.mciDto.privacyInclYn, toDepValue:toDeploy.mciDto.privacyInclYn});
			}
			if(this.isDiff(toDeploy.mciDto.currIntrfcIdentifier, toCompare.mciDto.currIntrfcIdentifier)){
				compareList.push({infoName:text.currIntrfcIdentifier, preDepValue:toCompare.mciDto.currIntrfcIdentifier, toDepValue:toDeploy.mciDto.currIntrfcIdentifier});
			}
			if(this.isDiff(toDeploy.mciDto.backupAprvStat, toCompare.mciDto.backupAprvStat)){
				compareList.push({infoName:text.backupAprvStat, preDepValue:toCompare.mciDto.backupAprvStat, toDepValue:toDeploy.mciDto.backupAprvStat});
			}
			if(this.isDiff(toDeploy.mciDto.occurCycle, toCompare.mciDto.occurCycle)){
				compareList.push({infoName:text.occurCycle, preDepValue:toCompare.mciDto.occurCycle, toDepValue:toDeploy.mciDto.occurCycle});
			}
			if(this.isDiff(toDeploy.mciDto.dayOccurCnt, toCompare.mciDto.dayOccurCnt)){
				compareList.push({infoName:text.dayOccurCnt, preDepValue:toCompare.mciDto.dayOccurCnt, toDepValue:toDeploy.mciDto.dayOccurCnt});
			}
			if(this.isDiff(toDeploy.mciDto.encTargetYn, toCompare.mciDto.encTargetYn)){
				compareList.push({infoName:text.encTargetYn, preDepValue:toCompare.mciDto.encTargetYn, toDepValue:toDeploy.mciDto.encTargetYn});
			}
		}else if(this.isDiff(toDeploy.intrfcTypeCd == 'EAI_I')){
			if(this.isDiff(toDeploy.intrfcWayCd, toCompare.intrfcWayCd)){
				compareList.push({infoName:text.trxTypeDscd, preDepValue:toCompare.intrfcWayCd, toDepValue:toDeploy.intrfcWayCd});
			}
			if(this.isDiff(toDeploy.eaiDto.timeOut, toCompare.eaiDto.timeOut)){
				compareList.push({infoName:text.timeout, preDepValue:toCompare.eaiDto.timeOut, toDepValue:toDeploy.eaiDto.timeOut});
			}
			if(this.isDiff(toDeploy.eaiDto.privacyInclYn, toCompare.eaiDto.privacyInclYn)){
				compareList.push({infoName:text.privacyInclYn, preDepValue:toCompare.eaiDto.privacyInclYn, toDepValue:toDeploy.eaiDto.privacyInclYn});
			}
			if(this.isDiff(toDeploy.eaiDto.currIntrfcIdentifier, toCompare.eaiDto.currIntrfcIdentifier)){
				compareList.push({infoName:text.currIntrfcIdentifier, preDepValue:toCompare.eaiDto.currIntrfcIdentifier, toDepValue:toDeploy.eaiDto.currIntrfcIdentifier});
			}
			if(this.isDiff(toDeploy.eaiDto.backupAprvStat, toCompare.eaiDto.backupAprvStat)){
				compareList.push({infoName:text.backupAprvStat, preDepValue:toCompare.eaiDto.backupAprvStat, toDepValue:toDeploy.eaiDto.backupAprvStat});
			}
			if(this.isDiff(toDeploy.eaiDto.occurCycle, toCompare.eaiDto.occurCycle)){
				compareList.push({infoName:text.occurCycle, preDepValue:toCompare.eaiDto.occurCycle, toDepValue:toDeploy.eaiDto.occurCycle});
			}
			if(this.isDiff(toDeploy.eaiDto.dayOccurCnt, toCompare.eaiDto.dayOccurCnt)){
				compareList.push({infoName:text.dayOccurCnt, preDepValue:toCompare.eaiDto.dayOccurCnt, toDepValue:toDeploy.eaiDto.dayOccurCnt});
			}
			if(this.isDiff(toDeploy.eaiDto.encTargetYn, toCompare.eaiDto.encTargetYn)){
				compareList.push({infoName:text.encTargetYn, preDepValue:toCompare.eaiDto.encTargetYn, toDepValue:toDeploy.eaiDto.encTargetYn});
			}
			if(this.isDiff(toDeploy.eaiDto.recvDbActionType, toCompare.eaiDto.recvDbActionType)){
				compareList.push({infoName:text.recvDbActionType, preDepValue:toCompare.eaiDto.recvDbActionType, toDepValue:toDeploy.eaiDto.recvDbActionType});
			}
			if(this.isDiff(toDeploy.eaiDto.lobColNm, toCompare.eaiDto.lobColNm)){
				compareList.push({infoName:text.lobColNm, preDepValue:toCompare.eaiDto.lobColNm, toDepValue:toDeploy.eaiDto.lobColNm});
			}
			if(this.isDiff(toDeploy.eaiDto.searchProcCnt, toCompare.eaiDto.searchProcCnt)){
				compareList.push({infoName:text.searchProcCnt, preDepValue:toCompare.eaiDto.searchProcCnt, toDepValue:toDeploy.eaiDto.searchProcCnt});
			}
			if(this.isDiff(toDeploy.eaiDto.errSkipYn, toCompare.eaiDto.errSkipYn)){
				compareList.push({infoName:text.errSkipYn, preDepValue:toCompare.eaiDto.errSkipYn, toDepValue:toDeploy.eaiDto.errSkipYn});
			}
			if(this.isDiff(toDeploy.eaiDto.recvDbQuery, toCompare.eaiDto.recvDbQuery)){
				compareList.push({infoName:text.recvDb2, preDepValue:toCompare.eaiDto.recvDbQuery, toDepValue:toDeploy.eaiDto.recvDbQuery});
			}
			if(this.isDiff(toDeploy.eaiDto.sendDbQuery, toCompare.eaiDto.sendDbQuery)){
				compareList.push({infoName:text.sendDb, preDepValue:toCompare.eaiDto.sendDbQuery, toDepValue:toDeploy.eaiDto.sendDbQuery});
			}
		}else if(this.isDiff(toDeploy.intrfcTypeCd == 'EAI_E')){
			if(this.isDiff(toDeploy.eaiDto.fepTranIntrfcId, toCompare.eaiDto.fepTranIntrfcId)){
				compareList.push({infoName:text.fepTranIntrfcId, preDepValue:toCompare.eaiDto.fepTranIntrfcId, toDepValue:toDeploy.eaiDto.fepTranIntrfcId});
			}
		}
		if(this.isDiff(toDeploy.intrfcTypeCd.indexOf('EAI') != -1)){
			if(this.isDiff(toDeploy.eaiDto.sendFilePath, toCompare.eaiDto.sendFilePath)){
				compareList.push({infoName:'송신-'+text.filepath2, preDepValue:toCompare.eaiDto.sendFilePath, toDepValue:toDeploy.eaiDto.sendFilePath});
			}
			if(this.isDiff(toDeploy.eaiDto.sendFileNm, toCompare.eaiDto.sendFileNm)){
				compareList.push({infoName:'송신-'+text.fileNm, preDepValue:toCompare.eaiDto.sendFileNm, toDepValue:toDeploy.eaiDto.sendFileNm});
			}
			if(this.isDiff(toDeploy.eaiDto.sendTranBeforeScript, toCompare.eaiDto.sendTranBeforeScript)){
				compareList.push({infoName:text.sendTranBeforeScript, preDepValue:toCompare.eaiDto.sendTranBeforeScript, toDepValue:toDeploy.eaiDto.sendTranBeforeScript});
			}
			if(this.isDiff(toDeploy.eaiDto.sendTranBeforeScriptType, toCompare.eaiDto.sendTranBeforeScriptType)){
				compareList.push({infoName:text.sendTranBeforeScriptType, preDepValue:toCompare.eaiDto.sendTranBeforeScriptType, toDepValue:toDeploy.eaiDto.sendTranBeforeScriptType});
			}
			if(this.isDiff(toDeploy.eaiDto.sendTranPostProc, toCompare.eaiDto.sendTranPostProc)){
				compareList.push({infoName:text.sendTranPostProc, preDepValue:toCompare.eaiDto.sendTranPostProc, toDepValue:toDeploy.eaiDto.sendTranPostProc});
			}
			if(this.isDiff(toDeploy.eaiDto.sendTranPostBackPath, toCompare.eaiDto.sendTranPostBackPath)){
				compareList.push({infoName:text.sendTranPostBackPath, preDepValue:toCompare.eaiDto.sendTranPostBackPath, toDepValue:toDeploy.eaiDto.sendTranPostBackPath});
			}
			if(this.isDiff(toDeploy.eaiDto.recvFilePath, toCompare.eaiDto.recvFilePath)){
				compareList.push({infoName:'수신-'+text.filepath2, preDepValue:toCompare.eaiDto.recvFilePath, toDepValue:toDeploy.eaiDto.recvFilePath});
			}
			if(this.isDiff(toDeploy.eaiDto.recvFileNm, toCompare.eaiDto.recvFileNm)){
				compareList.push({infoName:'수신-'+text.fileNm, preDepValue:toCompare.eaiDto.recvFileNm, toDepValue:toDeploy.eaiDto.recvFileNm});
			}
			if(this.isDiff(toDeploy.eaiDto.recvTranPostFinCreateYn, toCompare.eaiDto.recvTranPostFinCreateYn)){
				compareList.push({infoName:text.recvTranPostFinCreateYn, preDepValue:toCompare.eaiDto.recvTranPostFinCreateYn, toDepValue:toDeploy.eaiDto.recvTranPostFinCreateYn});
			}
			if(this.isDiff(toDeploy.eaiDto.recvTranPostScript, toCompare.eaiDto.recvTranPostScript)){
				compareList.push({infoName:text.recvTranPostScript, preDepValue:toCompare.eaiDto.recvTranPostScript, toDepValue:toDeploy.eaiDto.recvTranPostScript});
			}
			if(this.isDiff(toDeploy.eaiDto.recvTranPostScriptType, toCompare.eaiDto.recvTranPostScriptType)){
				compareList.push({infoName:text.recvTranPostScriptType, preDepValue:toCompare.eaiDto.recvTranPostScriptType, toDepValue:toDeploy.eaiDto.recvTranPostScriptType});
			}
			if(this.isDiff(toDeploy.eaiDto.recordSize, toCompare.eaiDto.recordSize)){
				compareList.push({infoName:text.recordSize, preDepValue:toCompare.eaiDto.recordSize, toDepValue:toDeploy.eaiDto.recordSize});
			}
			if(this.isDiff(toDeploy.eaiDto.recordSeparator, toCompare.eaiDto.recordSeparator)){
				compareList.push({infoName:text.recordSeparator, preDepValue:toCompare.eaiDto.recordSeparator, toDepValue:toDeploy.eaiDto.recordSeparator});
			}
		}
	}
	
	isDiff(toDep, toCom){
		if((toDep !== toCom)){
			if(!toDep && !toCom){
				return false;
			}
			return true;
		}
		return false;
	}
}

module(App.name).service('utilService', UtilService);


// WEBPACK FOOTER //
// ./src/app/common/service/util.service.js